import { RequestAffiliateLandingPage } from "../utils";
import axiosClient from "../../../../system/helpers/axiosConfig";

export const getLandingPageInfo = (params: RequestAffiliateLandingPage) => {
  return axiosClient
    .get(`/api/admin/landing-pages/edit`, { params })
    .then((r) => r.data);
};
